<template>
  <div>
    <v-progress-linear :indeterminate="loading"
                       v-if="loading">
    </v-progress-linear>
    <v-container class="d-flex">
      <v-icon class="mr-3"
              size="20">mdi-cash-multiple</v-icon>
      <h4 v-text="$t('servicesystem.common_objects.machine.service_level_measurement')" class="useThemeTextColor" />
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs"
                  v-on="on"
                  color="disabled">mdi-file-export</v-icon>
        </template>
        <span>Excel export is not available here yet ;)</span>
      </v-tooltip>
    </v-container>
    <v-divider />
    <v-container class="px-4">
      <v-row no-gutters>
        <v-col cols="auto-grow">{{ $t('servicesystem.common_objects.machine.cost') }}</v-col>
        <v-col cols="auto">{{ $t('servicesystem.common_objects.machine.yearly_total') }}</v-col>
      </v-row>
      <v-divider class="pb-2 mt-2" />
      <v-row no-gutters>
        <v-col cols="auto-grow">{{ $t('servicesystem.common_objects.machine.parts') }}</v-col>
        <v-col cols="auto">{{performanceData ? roundedDownTo2Decimals(performanceData.KPIPartCostYear) : 0}} ({{performanceData ? roundedDownTo2Decimals(performanceData.KPIPartCostTotal) : 0}})</v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="auto-grow">{{ $t('servicesystem.common_objects.machine.work_and_diving') }}</v-col>
        <v-col cols="auto">{{performanceData ? roundedDownTo2Decimals(performanceData.KPIWorkCostYear) : 0}} ({{performanceData ? roundedDownTo2Decimals(performanceData.KPIWorkCostTotal) : 0}})</v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="auto-grow">{{ $t('servicesystem.common_objects.machine.total') }}</v-col>
        <v-col cols="auto">{{performanceData ? roundedDownTo2Decimals(performanceData.KPITotalCostYear) : 0}} ({{performanceData ? roundedDownTo2Decimals(performanceData.KPITotalCostTotal) : 0}})</v-col>
      </v-row>
      <v-divider class="pb-2 mt-2" />
      <v-row no-gutters>
        <v-col cols="auto-grow">{{ $t('servicesystem.common_objects.machine.difference_from_yealy') }}</v-col>
        <v-col cols="auto">{{performanceData ? roundedDownTo2Decimals(performanceData.KPIDiffFromBudgetYear) : 0}}</v-col>
      </v-row>
    </v-container>
  </div>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";

export default {
  name: "PerformanceCard",
  props: ["id"],
  components: {},
  mixins: [clientAPI],

  data() {
    return {
      performanceData: null,
      loading: true,
    };
  },

  mounted() {
    this.getPerformance();
  },

  methods: {
    getPerformance() {
      this.loading = true;
      this.getMachinePerformanceById(this.id)
        .then((response) => {
          this.performanceData = response;
          
          
        })
        .catch((/*exception*/) => {

          this.performanceData = false;
        })
        .finally(() => (this.loading = false));
    },

    roundedDownTo2Decimals(number) {
      return number ? number.toFixed(2) : 0;
    },
  },

  computed: {},

  watch: {
    id: function () {
      this.getPerformance();
    },
  },
};
</script>